import { render } from "./NewConfirmModal.vue?vue&type=template&id=0daec320&scoped=true&ts=true"
import script from "./NewConfirmModal.vue?vue&type=script&lang=ts"
export * from "./NewConfirmModal.vue?vue&type=script&lang=ts"

import "./NewConfirmModal.vue?vue&type=style&index=0&id=0daec320&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daec320"]])

export default __exports__